import React from 'react';
import PropTypes from 'prop-types';
import DialogTitleModernTransparentHeader from './Variants/DialogTitleModernTransparentHeader';
import DialogTitleModernPrimaryHeader from './Variants/DialogTitleModernPrimaryHeader';
import DialogTitleDefault from './Variants/DialogTitleDefault';

function getTitleComponent(variant, primaryHeader) {
  switch (variant) {
    case 'modern':
      if (primaryHeader) {
        return DialogTitleModernPrimaryHeader;
      }

      return DialogTitleModernTransparentHeader;
    default:
    case 'default':
      return DialogTitleDefault;
  }
}

const DialogTitle = (props) => {
  const {
    primaryHeader,
    variant,
    ActionsProps,
    TitleTextProps,
  } = props;

  const TitleComponent = getTitleComponent(variant, primaryHeader);

  return (
    <TitleComponent
      ActionProps={ActionsProps}
      TitleTextProps={TitleTextProps}
    />
  );
};

DialogTitle.propTypes = {
  primaryHeader: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(['modern', 'default']).isRequired,
  ActionsProps: PropTypes.object.isRequired,
  TitleTextProps: PropTypes.object.isRequired,
};

export default DialogTitle;
